import { http } from "services/http";

import type {
  GeneratedDataDeleteRequest,
  GeneratedDataRequest,
  GeneratedDataResponse,
  GeneratorRunRequest,
  OperationListItem,
  OperationResponse,
  OperationSaveRequest,
  OperationUpdateRequest,
  OperationUpdateResponse,
  Project,
  ProjectListItem,
  ProjectReportsLinks,
  ProjectSaveRequest,
  ProjectsSelectMap,
  ProjectUpdateRequest,
  ProjectUpdateResponse,
  ReportsIdRequest,
  ReportsIdResponse,
} from "models/reports-generator.model";

export const reportsGeneratorApi = {
  getOperations: () => http.quiet().post<OperationListItem[]>("/api/statistics-generator/operations"),
  getOperationData: (data: ReportsIdRequest) =>
    http.quiet().post<OperationResponse>("/api/statistics-generator/get-operation", { ...data }),
  saveOperation: (data: OperationSaveRequest) =>
    http.quiet().post<ReportsIdResponse>("/api/statistics-generator/save-operation", { ...data }),
  updateOperation: (data: OperationUpdateRequest) =>
    http.quiet().post<OperationUpdateResponse>("/api/statistics-generator/update-operation", { ...data }),
  deleteOpertaion: (data: ReportsIdRequest) =>
    http.quiet().post("/api/statistics-generator/delete-operation", { ...data }),
  deleteAdditionalOpertaion: (data: ReportsIdRequest) =>
    http.quiet().post("/api/statistics-generator/delete-add-operation", { ...data }),

  getProjectsList: () => http.quiet().post<ProjectListItem[]>("/api/statistics-generator/projects"),
  getProjectData: (data: ReportsIdRequest) =>
    http.quiet().post<Project>("/api/statistics-generator/get-project", { ...data }),
  saveProject: (data: ProjectSaveRequest) =>
    http.quiet().post<ReportsIdResponse>("/api/statistics-generator/save-project", { ...data }),
  updateProject: (data: ProjectUpdateRequest) =>
    http.quiet().post<ProjectUpdateResponse>("/api/statistics-generator/update-project", { ...data }),
  deleteProject: (data: ReportsIdRequest) =>
    http.quiet().post("/api/statistics-generator/delete-project", { ...data }),
  deleteOperationWChances: (data: ReportsIdRequest) =>
    http.quiet().post("/api/statistics-generator/delete-project-operation-name", { ...data }),
  getProjectsSelectOptions: () =>
    http.quiet().post<ProjectsSelectMap>("/api/statistics-generator/create-operations"),
  deleteSpending: (data: ReportsIdRequest) =>
    http.quiet().post("/api/statistics-generator/delete-project-spending-name", { ...data }),

  runReportsGenerator: (data: GeneratorRunRequest) =>
    http.quiet().post("/api/statistics-generator/run", { ...data }),
  deleteReportsGeneratorData: (data: GeneratedDataDeleteRequest) =>
    http.quiet().post("/api/statistics-generator/delete-generated-data", { ...data }),
  getGeneratedData: (data?: GeneratedDataRequest) =>
    http.quiet().post<GeneratedDataResponse>("/api/statistics-generator", data ? { ...data } : null),
  runPDFReportsGenerator: (data: ReportsIdRequest) =>
    http.quiet().post("/api/statistics-generator-reports/run", { ...data }),
  getProjectsReportsLink: (data: ReportsIdRequest) =>
    http.quiet().post<ProjectReportsLinks>("/api/statistics-generator-reports", { ...data }),
};
